import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { useDatabridge } from '@xp-utilities/web';
import * as FormStructure from '../FormStructure';
import { ERROR_MESSAGE, LOADING_MESSAGE } from '../Messages/Messages';
import DefaultAddress from '../CheckoutInfoBlock/DefaultAddress';
import { MY_ADDRESS_QUERY } from './operations';
import FieldTitle from '../FieldTitle/FieldTitle';
import AccountUniversalWrapper from '../Common/AccountUniversalWrapper/AccountUniversalWrapper';

export default function MyAddress({ hasProfileCompletionEnabled }) {
  const [, setAddress] = useDatabridge('analytics.global.account.profile_completion.has_default_address');
  const { loading, error, data } = useQuery(MY_ADDRESS_QUERY, {
    context: { batch: true },
  });

  const {
    textFor = {},
    getDefaultAddress: defaultAddress,
    getAddressPageURL: addressPageURL,
  } = data || {};

  const {
    addressCardTitle,
    addressCardDefault,
    changeText,
    noDefaultAddress,
    selectAddress,
    addAddress,
    myInfoAddress,
    myInfoAddressDescription,
  } = textFor || {};

  useEffect(() => {
    if (defaultAddress) {
      setAddress(true);
    } else {
      setAddress(false);
    }
  }, [defaultAddress, setAddress]);

  if (loading) return LOADING_MESSAGE;
  if (error) return ERROR_MESSAGE;

  return (
    <FormStructure.FormGroup>
      <FormStructure.FormCell>
        <AccountUniversalWrapper
          marginTop="25px"
          marginBottom="25px"
          className="my-address-wrapper"
        >
          <FieldTitle
            title={myInfoAddress.value}
            titleTextKey={myInfoAddress.key}
            subText={myInfoAddressDescription.value}
            subTextKey={myInfoAddressDescription.key}
          />

          <DefaultAddress
            address={defaultAddress}
            cardTitle={addressCardTitle}
            cardDefaultText={addressCardDefault}
            changeText={changeText}
            noDefaultAddress={noDefaultAddress}
            pageLink={addressPageURL}
            selectAddressText={selectAddress}
            addAddressText={addAddress}
            hasProfileCompletionEnabled={hasProfileCompletionEnabled}
          />
        </AccountUniversalWrapper>
      </FormStructure.FormCell>
    </FormStructure.FormGroup>
  );
}

MyAddress.propTypes = { hasProfileCompletionEnabled: PropTypes.bool };
MyAddress.defaultProps = { hasProfileCompletionEnabled: false };
